const investmentWidget = (state = [], action) => {
  switch (action.type) {
    default: return state;
  }
};

export default investmentWidget;
